(function(){
  var defined = ['shopify.com/extensions','portable-wallets'];
  var obs = new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      for(var j=0;j<muts[i].addedNodes.length;j++){
        var n = muts[i].addedNodes[j];
        if(n.tagName==='LINK'&&n.rel==='stylesheet'){
          var h=n.href||'';
          for(var k=0;k<defined.length;k++){
            if(h.indexOf(defined[k])!==-1){
              n.media='print';
              n.onload=function(){this.media='all'};
              break;
            }
          }
        }
      }
    }
  });
  obs.observe(document.head,{childList:true,subtree:true});
  setTimeout(function(){obs.disconnect()},5000);
})();